type competitorList = string[];

export type Competitor = { key: string; name: string; image: string };

export const allCompetitors: Competitor[] = [
  {
    key: "amazon",
    name: "Amazon",
    image: "https://static.johnlewiscontent.com/v1/static/amazon",
  },
  {
    key: "ao",
    name: "AO",
    image: "https://static.johnlewiscontent.com/v1/static/ao",
  },
  {
    key: "apple",
    name: "Apple",
    image: "https://static.johnlewiscontent.com/v1/static/apple",
  },
  {
    key: "argos",
    name: "Argos",
    image: "https://static.johnlewiscontent.com/v1/static/argos",
  },
  {
    key: "asos",
    name: "ASOS",
    image: "https://static.johnlewiscontent.com/v1/static/asos",
  },
  {
    key: "boots",
    name: "Boots",
    image: "https://static.johnlewiscontent.com/v1/static/boots",
  },
  {
    key: "currys",
    name: "Currys",
    image: "https://static.johnlewiscontent.com/v1/static/currys",
  },
  {
    key: "dreams",
    name: "Dreams",
    image: "https://static.johnlewiscontent.com/v1/static/dreams",
  },
  {
    key: "dunhelm",
    name: "Dunhelm",
    image: "https://static.johnlewiscontent.com/v1/static/dunhelm",
  },
  {
    key: "flannels",
    name: "Flannels",
    image: "https://static.johnlewiscontent.com/v1/static/flannels",
  },
  {
    key: "furniture-village",
    name: "Furniture Village",
    image: "https://static.johnlewiscontent.com/v1/static/furniture-village",
  },
  {
    key: "harrods",
    name: "Harrods",
    image: "https://static.johnlewiscontent.com/v1/static/harrods",
  },
  {
    key: "harvey-nichols",
    name: "Harvey Nichols",
    image: "https://static.johnlewiscontent.com/v1/static/harvey-nichols",
  },
  {
    key: "heals",
    name: "Heals",
    image: "https://static.johnlewiscontent.com/v1/static/heals",
  },
  {
    key: "house-of-fraser",
    name: "House Of Fraser",
    image: "https://static.johnlewiscontent.com/v1/static/house-of-fraser",
  },
  {
    key: "lakeland",
    name: "Lakeland",
    image: "https://static.johnlewiscontent.com/v1/static/lakeland",
  },
  {
    key: "m-s",
    name: "M & S",
    image: "https://static.johnlewiscontent.com/v1/static/m&s",
  },
  {
    key: "mamas-papas",
    name: "Mamas & Papas",
    image: "https://static.johnlewiscontent.com/v1/static/mamas-&-papas",
  },
  {
    key: "next",
    name: "Next",
    image: "https://static.johnlewiscontent.com/v1/static/next",
  },
  {
    key: "richer-sounds",
    name: "Richer Sounds",
    image: "https://static.johnlewiscontent.com/v1/static/richer-sounds",
  },
  {
    key: "selfridges",
    name: "Selfridges",
    image: "https://static.johnlewiscontent.com/v1/static/selfridges",
  },
  {
    key: "sephora",
    name: "Sephora",
    image: "https://static.johnlewiscontent.com/v1/static/sephora",
  },
  {
    key: "smiths",
    name: "Smiths",
    image: "https://static.johnlewiscontent.com/v1/static/smiths",
  },
  {
    key: "space-nk",
    name: "Space NK",
    image: "https://static.johnlewiscontent.com/v1/static/spacenk",
  },
  {
    key: "the-entertainer",
    name: "The Entertainer",
    image: "https://static.johnlewiscontent.com/v1/static/the-entertainer",
  },
];

export const fashionCompetitors: competitorList = [
  "asos",
  "next",
  "flannels",
  "house-of-fraser",
];

export const beautyCompetitors: competitorList = [
  "boots",
  "space-nk",
  "harvey-nichols",
  "selfridges",
];

export const electricalsCompetitors: competitorList = [
  "amazon",
  "ao",
  "currys",
  "argos",
];
